import { DropdownOption } from "@xapp/components";

function buildTimeOptions(): DropdownOption[] {
    const options: DropdownOption[] = [];

    for (let hour = 6; hour <= 21; hour++) {
        for (const minute of ["00", "30"]) {
            const value = `${`${hour}`.padStart(2, "0")}:${minute}`;
            const meridiem = hour < 12 ? "AM" : "PM";
            const displayHour = hour % 12 === 0 ? 12 : hour % 12;
            options.push({ value, text: `${displayHour}:${minute} ${meridiem}` });
        }
    }

    return options;
}

/**
 * The times a same-day cutoff can be set to, in 30-minute increments across the whole working
 * day. The list used to be hourly 9am-6pm, which is too coarse for the cutoff to be useful -
 * a 4pm cutoff is the entire point of same-day booking.
 */
export const TIME_OPTIONS: readonly DropdownOption[] = buildTimeOptions();
